<template>
	<div class="v5-countdown">
		<div class="v5-countdown-main">
			<!-- 天 -->
			<template v-if="type === 0">
				<span class="v5-countdown-num">
					<scrollnum :num="day" :width="width" :height="height" :size="size"></scrollnum>
				</span>
				<span class="v5-countdown-colon">天</span>
			</template>
			<!-- 时 -->
			<template v-if="type !== 2">
				<span class="v5-countdown-num">
					<scrollnum :num="hour" :width="width" :height="height" :size="size"></scrollnum>
				</span>
				<span class="v5-countdown-colon">:</span>
			</template>
			<!-- 分 -->
			<span class="v5-countdown-num">
				<scrollnum :num="minute" :width="width" :height="height" :size="size"></scrollnum>
			</span>
			<span class="v5-countdown-colon" v-if="type !== 3">:</span>
			<!-- 秒 -->
			<span class="v5-countdown-num" v-if="type !== 3">
				<scrollnum :num="second" :width="width" :height="height" :size="size"></scrollnum>
			</span>
		</div>
	</div>
</template>

<script>
/**
 * 倒计时组件
 * @param {date} [type] - 计时类型（0-天时分秒 1-时分秒 2-分秒 3-时分）
 * @param {date} [end] - 结束时间
 * @param {date} [width] - 数字宽度
 * @param {date} [height] - 数字高度
 * @param {date} [size] - 数字字号
 */
import Scrollnum from '../scrollnum';

export default {
	name: 'v5-countdown',
	props: {
		type: {
			type: Number,
			default: 0
		},
		end: {
			type: Date,
			default: new Date()
		},
		width: {
			type: Number,
			default: 20
		},
		height: {
			type: Number,
			default: 56
		},
		size: {
			type: Number,
			default: 34
		}
	},
	data() {
		return {
			day: '00', // 剩余的天数
			hour: '00', // 剩余的小时数
			minute: '00', // 剩余的分钟数
			second: '00', // 剩余的秒数
			leftTime: '00', // 剩余的总秒数
			timer: null // 计时器
		};
	},
	created() {
		this.leftTime = (this.end.getTime() - new Date().getTime()) / 1000;
		this.resetTime(); // 初始化数据
		// 开始倒计时
		this.timer = setInterval(() => {
			this.leftTime--;
			if (this.leftTime <= 0) {
				clearInterval(this.timer);
			}
			this.resetTime();
		}, 1000);
	},
	methods: {
		/**
		 * 剩余时间初始化
		 */
		resetTime() {
			this.leftTime = this.leftTime <= 0 ? 0 : this.leftTime;
			this.day = this.fixTime(parseInt(this.leftTime / 60 / 60 / 24, 10));
			this.hour = this.fixTime(parseInt(this.leftTime / 60 / 60 % 24, 10));
			this.minute = this.fixTime(parseInt(this.leftTime / 60 % 60, 10));
			this.second = this.fixTime(parseInt(this.leftTime % 60, 10));
		},
		/**
		 * 时间格式化
		 * 不够两位时用 0 补位
		 */
		fixTime(time) {
			return time < 10 ? '0' + time : time;
		}
	},
	destroyed() {
		clearInterval(this.timer); // 清除定时器
	},
	components: {
		Scrollnum
	}
};
</script>

<style lang="scss">
@import './style.scss';
</style>
